export default "__VITE_ASSET__j9j7t7eU__"